import React from "react";

import StandardModal from "./shared/StandardModal";
import { MoveFocusInside } from "react-focus-lock";
import iconHelpBlue from "assets/IconHelpBlue.svg?url";
import Tooltip from "rc-tooltip";
import { Spinner, Textarea } from "@chakra-ui/react";
import "rc-tooltip/assets/bootstrap.css";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { sendAnnouncement } from "js/api/eventApi";
import { useSelectedClassroomStore } from "stores/v2/selectedClassroomStore";
import { withTranslation } from "react-i18next";

class SendMessageModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentMessage: "",
			sending: false,
			error: false,
		};
	}

	async sendMessage() {
		const { t } = this.props;
		if (this.state.currentMessage.length === 0) {
			this.setState({ error: t("sendMessageModal.emptyMessageError") });
			return;
		}

		this.setState({ sending: true, error: false });

		const payload = {
			classroom_source_id: this.props.classroomSourceId,
			event_object: {
				event: "MESSAGE",
				value: this.state.currentMessage,
			},
		};
		if (this.props.users) {
			payload.recipients = this.props.users.map((user) => user.username);
		}

		sendAnnouncement(
			this.props.classroomSourceId,
			useSelectedClassroomStore.getState().stableIdV1,
			this.state.currentMessage,
			this.props.users?.map((user) => user.username)
		)
			.then(() => {
				this.close();
				this.clear();
			})
			.catch(() =>
				this.setState({
					sending: false,
					error: t("sendMessageModal.sendError"),
				})
			);
	}

	renderButtons = () => {
		const { t } = this.props;
		let sendButton = (
			<PrimaryButton className="mui-flat-button" label={t("sendMessageModal.sendButton")} onClick={this.sendMessage.bind(this)} />
		);
		if (this.state.sending) {
			sendButton = <PrimaryButton className="mui-flat-button" label={<Spinner color="white" width={"12px"} height={"12px"} />} />;
		}
		return <React.Fragment>{sendButton}</React.Fragment>;
	};

	clear = () => {
		this.setState({ currentMessage: "" });
	};

	close = () => {
		this.setState({ sending: false });
		this.props.onClose();
	};

	handleChange(event) {
		const { t } = this.props;
		let errorMessage = false;
		if (event.target.value.length >= this.props.maxMessageLength) {
			errorMessage = t("sendMessageModal.maxCharactersReached", { max: this.props.maxMessageLength });
		} else if (event.target.value.length >= this.props.maxMessageLength - 20) {
			errorMessage = t("sendMessageModal.characterCount", {
				current: event.target.value.length,
				max: this.props.maxMessageLength,
			});
		}
		this.setState({ currentMessage: event.target.value, error: errorMessage });
	}

	keypressValidation = (event) => {
		if (this.state.currentMessage.length >= this.props.maxMessageLength) {
			event.preventDefault();
		}
	};

	render() {
		const { t } = this.props;
		return (
			<StandardModal
				size="medium"
				open={this.props.open}
				close={this.close}
				actions={this.renderButtons()}
				header={
					<div className="SendMessageModal_header">
						<h2 className="SendMessageModal_headerText" title={this.props.title}>
							{this.props.title}
						</h2>
						&nbsp;
						<Tooltip
							placement="bottom"
							trigger={["hover"]}
							destroyTooltipOnHide={true}
							overlayClassName="Tooltip"
							overlay={<span>{t("sendMessageModal.learnMoreTooltip")}</span>}
						>
							<a href="https://docs.classwize.net/help/intro-classtools#announcement" target="_blank" rel="noopener noreferrer">
								<img className="SendMessageModal_helpIcon" src={iconHelpBlue} alt="" />
							</a>
						</Tooltip>
					</div>
				}
			>
				<div>{this.props.subtitle}</div>
				&nbsp;
				<form onSubmit={(ev) => ev.preventDefault()}>
					<MoveFocusInside>
						<Textarea
							className="SendMessageModal_textarea"
							name="messageBody"
							placeholder={t("sendMessageModal.messagePlaceholder")}
							onChange={this.handleChange.bind(this)}
							value={this.state.currentMessage}
							onKeyPress={this.keypressValidation}
							sx={{ height: "21vh", mh: "290px" }}
						/>
					</MoveFocusInside>
					{this.state.error && <div className={"error"}>{this.state.error}</div>}
				</form>
			</StandardModal>
		);
	}
}

export default withTranslation()(SendMessageModal);
